import React, { type FunctionComponent } from 'react'
import { trackAnalyticEvent } from '../../../utils'
import { LearnButton } from '../learn-button'
import { HELP_URL, WHATS_NEW_URL } from './learn-button-content.constants'

type LearnButtonContentProps = {
	analyticsLocation: string,
}

export const LearnButtonContent: FunctionComponent<LearnButtonContentProps> = ( { analyticsLocation } ) => (
	<LearnButton
		helpUrl={HELP_URL}
		whatsNewUrl={WHATS_NEW_URL}
		onHelpClick={() => {
			trackAnalyticEvent(
				analyticsLocation,
				'Click',
				'Learn - Help Articles',
			)
		}}
		onWhatsNewClick={() => {
			trackAnalyticEvent(
				analyticsLocation,
				'Click',
				'Learn - What\'s New',
			)
		}}
	/>
)
